import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getLaundryResources } from './api';
import { mapDataForClient } from './mapData';

const LAUNDRY_RESOURCES = 'laundryResources';

export function useLaundryResources(shouldDisableQuery = false) {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery(
    [LAUNDRY_RESOURCES, tenantId],
    () => getLaundryResources(),
    {
      enabled: !shouldDisableQuery,
    },
  );

  return {
    laundryResources:
      data?.resources?.map((resource) => mapDataForClient(resource)) || [],
    isLoading,
    isFetching,
    isError,
  };
}
